import { MULTIPLE_STRATEGIES } from '@domain/segments/segments-table/segments-table.constants';

export const ESC_KEYCODE = 27;

export const EDIT_CURRENCY_FIELD_TEST_IDS = {
    EDIT_CURRENCY_FIELD: 'money-input',
    ICON_PENCIL: 'edit-field-icon-pencil',
};

export const MINIMUM_PERFORMANCE_VALUE_WARNING = `It's only possible to edit this field when the value of Bid Strategy is not  "${MULTIPLE_STRATEGIES}"`;
